module.exports = (__webpack_require__(7))(876);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/module.js from dll-reference vendor
// module id = 625
// module chunks = 0